import { comics } from '@/mocks/manga';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  latestChapter: string;
  category?: string;
}

export default function ComicCard({ id, title, author, cover, rating, status, latestChapter }: ComicCardProps) {
  const comic = comics.find(c => c.id === id);

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={`${title} 漫画封面`}
          title={`${title} - 51漫画网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
            status === '已完结' ? 'bg-accent-500 text-background-50' : 'bg-primary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5 flex items-center gap-1">
          <i className="ri-star-fill text-yellow-400 text-xs"></i>
          <span className="text-xs text-background-50 font-semibold">{rating}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <p className="text-xs text-background-200 truncate">最新: {latestChapter}</p>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{title}</h3>
        <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
      </div>
    </Link>
  );
}

export function ComicCardSimple({ id, title, author, cover, rating }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
    >
      <div className="w-14 h-14 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
        <img src={cover} alt={title} className="w-full h-full object-cover object-top" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{title}</p>
        <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        <i className="ri-star-fill text-yellow-400 text-xs"></i>
        <span className="text-xs font-semibold text-foreground-700">{rating}</span>
      </div>
    </Link>
  );
}